import type { FC } from 'react';

import * as S from './elements';

type Props = {
  onLeftButtonClick: () => void;
  onRightButtonClick: () => void;
  leftButtonText: string;
  rightButtonText: string;
  loading?: boolean;
  rightButtonPrimary?: boolean;
};

export const FooterMobile: FC<Props> = ({
  onLeftButtonClick,
  onRightButtonClick,
  leftButtonText,
  rightButtonText,
  loading = false,
  rightButtonPrimary = false,
}) => {
  return (
    <S.Footer>
      <S.FooterButton onClick={onLeftButtonClick}>
        {leftButtonText}
      </S.FooterButton>
      <S.FooterButton
        onClick={onRightButtonClick}
        type={rightButtonPrimary ? 'primary' : 'secondary'}
        loading={loading}
      >
        {rightButtonText}
      </S.FooterButton>
    </S.Footer>
  );
};
